module.exports = __webpack_public_path__ + "img/paypal-dent-red.09a1cda8.svg";